import { useStaticQuery, graphql } from "gatsby"
export const useProductNew = () => {
  const data = useStaticQuery(graphql`
      query {
        allMarkdownRemark(
          limit: 30
          filter: {fileAbsolutePath: {regex: "/content/"}, frontmatter: {group: {eq: "product"}, draft: {eq: false}}}
          sort: {frontmatter: {lastmod: DESC}}
        ) {
          nodes {
            excerpt(truncate: true, pruneLength: 100)
            frontmatter {
              date(formatString: "YYYY / MM / DD")
              lastmod(formatString: "YYYY / MM / DD")
              url
              image
              title
              description
              category
              price
            }
          }
        }
      }
    `
  )
  return data.allMarkdownRemark.nodes
}